import moment from "moment"

// Returns a moment object for the next allowed order day
export function getDate(setLimitDay, setLimitHour) {
  let orderDay;
  if (moment().format("E") < setLimitDay) {
    orderDay = moment().startOf("isoWeek").add(1, "week");
  } else if (moment().format("E") == setLimitDay) {
    if (setLimitHour < moment().format("H")) {
      orderDay = moment().startOf("isoWeek").add(2, "week");
    } else if (setLimitHour == moment().format("H")) {
      if (moment().format("m") == 0) {
        orderDay = moment().startOf("isoWeek").add(1, "week");
      } else {
        orderDay = moment().startOf("isoWeek").add(2, "week");
      }
    } else {
      orderDay = moment().startOf("isoWeek").add(1, "week");
    }
  } else {
    orderDay = moment().startOf("isoWeek").add(2, "week");
  }
  orderDay.set("hour", setLimitHour);
  orderDay.set("minute", 0);
  return orderDay;
}

// Finds the shift key string based on a number
export function findShift(num) {
  switch (num) {
    case 1:
      return "shift_one";
    case 2:
      return "shift_two";
    case 3:
      return "shift_three";
  }
}

// Sets a cookie with the given name, value, and expiration in hours
export function setCookie(name, value, hours) {
  let expires = "";
  if (hours) {
    let date = new Date();
    date.setTime(date.getTime() + hours * 60 * 60 * 1000);
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie =
    name +
    "=" +
    (value || "") +
    expires +
    "; path=/; domain=.ordera.app; secure; SameSite=Lax";
}

// Checks if a menu date should be disabled based on restaurant order time config
export function checkDisabled(menuDate, restaurantOrderTime, company, user) {
  if (!restaurantOrderTime) return false;
  if (company?.no_time_limit && user?.no_time_limit_user) {
    return false;
  }
  if (!menuDate || !moment(menuDate, "YYYY-MM-DD", true).isValid()) {
    return true;
  }
  const today = moment();
  const menuMoment = moment(menuDate, "YYYY-MM-DD");
  const dayKey = today.format("dddd").toLowerCase();
  const dayConfig = restaurantOrderTime[dayKey];
  if (!dayConfig || !dayConfig.time) return false;
  const cutoff = today
    .clone()
    .set("hour", dayConfig.time.time_hour || 0)
    .set("minute", dayConfig.time.time_minut || 0)
    .set("second", 0)
    .set("millisecond", 0);
  const addDays = today.isBefore(cutoff)
    ? dayConfig.day_before_limit
    : dayConfig.day_after_limit;
  const lastAllowed = today.clone().add(addDays, "days").startOf("day");
  if (menuMoment.isAfter(lastAllowed, "day")) {
    return true;
  }
  return false;
}

// Optionally, export convertNameOfDay if you want to move it here
export function openOrdera(res) {
  let token = localStorage.getItem("restoran-token");
  setCookie("restoran-token", token, 0.05);
  let convertCyToLa = require("cyrillic-to-latin");
  let url =
    "https://ordera.app/sr/" +
    res.city.country.code +
    "/" +
    res.city.code +
    "/" +
    convertCyToLa(res.name.toLowerCase()).replace(" ", "-") +
    "/" +
    res.id;
  window.location.replace(url);
}
